import React from "react";
import { getImageFramePaths, imageFramePathData } from "./ShareImageFrame";

export default function ShareImageFramePreview({ scene, frame, className = "share-editor-frame-overlay" }) {
  const paths = getImageFramePaths(scene, frame);
  if (!paths.length) return null;
  return <svg className={className} viewBox={`0 0 ${scene.width} ${scene.height}`} fill="none" aria-hidden="true" focusable="false">
    {paths.map((path,index) => <path key={index} d={imageFramePathData(path.segments)} stroke={path.color} strokeWidth={path.width} opacity={path.opacity} strokeLinecap="round" strokeLinejoin="round" />)}
  </svg>;
}
